import React from "react";
import "./admissionRequirements.css";
import Logo from "../homepage/home_pictures/logos/Manga_Cons _Logo3.png";
import { useNavigate } from "react-router-dom";

const AdmissionRequirements = () => {
  const redirect = useNavigate();
  return (
    <div className="admissionreq-container">
      <h1 className="admissionreq-heading fx-cl fx-ac space2">
        <img src={Logo} alt="MangaCONS Logo" />
        <span> Admission Requirements into MangaCONS</span>
      </h1>

      <div className="admissionreq-section">
        <h2>General Nursing Education</h2>
        <p>
          Candidates seeking admission into the General Nursing Education must
          possess the following:
        </p>
        <ul>
          <li>
            A minimum of five (5) subjects at credit level in the Senior
            Secondary School Certificate from the{" "}
            <strong>West African Examinations Council (WAEC)</strong> or the{" "}
            <strong>National Examinations Council (NECO)</strong>.
          </li>
          <li>
            The required subjects are:
            <ul>
              <li>English Language</li>
              <li>Mathematics</li>
              <li>Physics</li>
              <li>Chemistry</li>
              <li>Biology</li>
            </ul>
          </li>
          <li>
            National Business and Technical Examination Board (
            <strong>NABTEB</strong>) is also accepted but{" "}
            <strong>cannot be combined</strong> with any other O’level
            credentials.
          </li>
          <li>
            Results must be obtained in{" "}
            <strong>not more than two (2) sittings</strong>.
          </li>
          <li>
            JAMB requirement: <strong>2026 UTME </strong>.
          </li>
          <li>
            JAMB Results must be a <strong>minimum score: 150</strong>.
          </li>
        </ul>
      </div>
      <div className="admissionreq-section">
        <h2>Programme Description</h2>
        <p>
          The <strong>General Nursing Programme</strong> structure includes:
        </p>
        <ul>
          <li>
            A <strong>3-year programme</strong> for General Nursing students in
            approved institutions of Nursing.
          </li>
        </ul>
      </div>
      <div className="admissionreq-section">
        <h2>Midwifery Programme</h2>
        <p>
          Candidates seeking admission into the{" "}
          <strong>Midwifery Programme</strong> must meet the following
          requirements:
        </p>
        <ul>
          <li>
            A minimum of five (5) credits in subjects including:
            <ul>
              <li>English Language</li>
              <li>Mathematics</li>
              <li>Physics</li>
              <li>Chemistry</li>
              <li>Biology</li>
            </ul>
          </li>
          <li>
            Accepted examination boards include:
            <ul>
              <li>
                West African Examination Council (<strong>WAEC</strong>).
              </li>
              <li>
                National Examination Council (<strong>NECO</strong>).
              </li>
              <li>
                National Business and Technical Examination Board (
                <strong>NABTEB</strong>). NABTEB stands on its own and cannot be
                combined with other O’level credentials.
              </li>
            </ul>
          </li>
          <li>
            Results must be obtained in{" "}
            <strong>not more than two (2) sittings</strong>.
          </li>
          <li>
            JAMB requirement: <strong>2026 UTME </strong>.
          </li>
          <li>
            A minimum <strong>JAMB score: 150</strong>.
          </li>
          <li>
            For <strong>Post-Basic Midwifery</strong>, candidates must:
            <ul>
              <li>
                Be a <strong>Registered Nurse (RN)</strong> with the Nursing and
                Midwifery Council of Nigeria.
              </li>
              <li>
                Possess a <strong>current practicing license</strong>.
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div className="admissionreq-section">
        <h2>Programme Description</h2>
        <p>
          The <strong>Midwifery Programme</strong> structure includes:
        </p>
        <ul>
          <li>
            A <strong>3-year programme</strong> for Basic Midwifery students in
            approved institutions of Midwifery.
          </li>
          <li>
            An <strong>18-month programme</strong> for Post-Basic Midwifery
            students.
          </li>
        </ul>
      </div>
      <div className="admissionreq-section">
        <h2>Student Intake</h2>
        <ul>
          <li>
            Admission intake depends on the pathway and availability of human
            and material resources.
          </li>
        </ul>
      </div>
      <div className="final-reminder">
        <p>
          <strong>Important:</strong> All candidates are advised to ensure they
          meet the stated requirements before applying. Incomplete or inaccurate
          applications will not be processed.
        </p>
      </div>
      <button
        className="adm-btn"
        onClick={() => redirect("/registrations")}
        style={{
          backgroundColor: "green",
          padding: ".7rem 2.1rem",
          color: "#fff",
          marginTop: "2.4rem",
        }}
      >
        Start your applicatoin here
      </button>
    </div>
  );
};

export default AdmissionRequirements;
